// Klient pro /api/read-state/* — markuje entity jako viděné uživatelem.
// Po úspěšném mark volá sidebar stats refetch, takže badge ihned klesne.
import api from '@/lib/api';

// Kategorie, které backend podporuje (ALLOWED_ENTITY_TYPES v read_states.py).
export const ENTITY_TYPES = {
  CALIBRATION: 'calibration',
  ORDER: 'order',
  INTAKE: 'intake',
  DISPATCH: 'dispatch',
};

/**
 * Označí seznam IDs jako viděné (fail-silent — UX nic neblokuje).
 * @param {string} entityType — jedna z ENTITY_TYPES
 * @param {string[]} ids — pole entity IDs
 */
export async function markListSeen(entityType, ids) {
  if (!entityType || !Array.isArray(ids) || ids.length === 0) return;
  try {
    await api.post('/read-state/mark-list', { entityType, ids });
  } catch {
    // silent — nejde o kritickou operaci
  }
}

/**
 * Označí jeden konkrétní záznam (např. otevření detail stránky).
 */
export async function markEntitySeen(entityType, id) {
  if (!entityType || !id) return;
  try {
    await api.post(`/read-state/mark-entity/${entityType}/${id}`);
  } catch {
    // silent
  }
}
